import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class DeliRouteService {
  private apiUrl = '/deliroutes';
  private apiSpringUrl = '/spring/deliroutes';

  constructor(private http: HttpService) { }

  get(query?: any): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}`;
    return this.http.get(url, query);
  }

  post(
    ownerId: number,
    delirouteCd: string,
    delirouteTx: string,
    deliareaId: number,
    updprogramCd: string
  ): Promise<any> {
    const url = `${environment.baseUrl}/owners/${ownerId + this.apiUrl}`;
    const jsonInput = {
      delirouteCd: delirouteCd,
      delirouteTx: delirouteTx,
      deliareaId: deliareaId,
      updprogramCd: updprogramCd
    };

    return this.http.post(url, jsonInput);

  }

  put(
    ownerId: number,
    delirouteId: number,
    delirouteCd: string,
    delirouteTx: string,
    deliareaId: number,
    updprogramCd: string
  ): Promise<any> {
    const url = `${environment.baseUrl}/owners/${ownerId + this.apiUrl}/${delirouteId}`;
    const jsonInput = {
      delirouteCd: delirouteCd,
      delirouteTx: delirouteTx,
      deliareaId: deliareaId,
      updprogramCd: updprogramCd
    };

    return this.http.put(url, jsonInput);
  }

  delete(
    ownerId: number,
    delirouteId: number
  ): Promise<any> {
    const url = `${environment.baseUrl}/owners/${ownerId + this.apiUrl}/${delirouteId}`;
    return this.http.delete(url);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/deli-route/deli-route.service.ts